import { Ca2Model } from './../../models/societe-linked/ca2.model';
import { SocieteLinkedService } from './societe-linked.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { APICONSTANTS } from '../../constants/api-constants';
import { HostnameService } from '../basic/hostname.service';

@Injectable()
export class Ca2Service extends SocieteLinkedService<Ca2Model> {
    constructor(http: HttpClient,
                protected toastrService: ToastrService,
                protected hostnameService: HostnameService) {
        super(http, toastrService, APICONSTANTS.ROUTECA2, hostnameService);
  }

  getFromNaCa1(idSoc: any, codeNa: string, codeCa1: string, type: string): Observable<Ca2Model[]> {
    // tslint:disable-next-line
    return this.http.get<Ca2Model[]>(APICONSTANTS.URLAPI.value + this.route + 'getFromNaCa1?idSociete=' + idSoc + '&codeNa=' + codeNa + '&codeCa1=' + codeCa1 + '&type=' + type)
      .pipe(catchError(err => this.requestCatchError(err, 'Le chargement')));
  }
}
